"use strict";module.exports={HTTP_URL:"http://a.tiles.mapbox.com",HTTPS_URL:"https://a.tiles.mapbox.com",FORCE_HTTPS:!1,REQUIRE_ACCESS_TOKEN:!0};